import { cloneDeep } from 'lodash-es';
import type { editor } from 'monaco-editor/esm/vs/editor/editor.api.d.ts';
export const darkTheme: editor.IStandaloneThemeData = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    // { foreground: 'f8fafcff' },
    { token: 'comment', foreground: '94a3b8ff' },
    { token: 'string', foreground: 'cde3fcff' },
    { token: 'number', foreground: 'fed7aaff' },
    { token: 'boolean', foreground: 'fed7aaff' },
    { token: 'keyword', foreground: 'fed7aaff' },
    { token: 'tag', foreground: 'f472b6ff' },
    { token: 'delimiter', foreground: '64748bff' },
    { token: 'attribute.name.html', foreground: 'cbd5e1ff' },
    { token: 'attribute.value.html', foreground: 'cde3fcff' },
    { token: 'delimiter.html', foreground: '64748bff' },
    { token: 'keyword.js', foreground: 'cbd5e1ff' },
    { token: 'identifier.js', foreground: 'f8fafcff' },
    { token: 'attribute.name.css', foreground: 'cde3fcff' },
    { token: 'attribute.value.unit.css', foreground: '99f6e4ff' },
    { token: 'attribute.value.number.css', foreground: 'f8fafcff' },
    { token: 'attribute.value.css', foreground: 'f8fafcff' },
    { token: 'attribute.value.hex.css', foreground: 'f8fafcff' },
    { token: 'keyword.css', foreground: 'cbd5e1ff' },
    { token: 'function.css', foreground: '99f6e4ff' },
    { token: 'pseudo.css', foreground: 'cbd5e1ff' },
    { token: 'variable.css', foreground: 'f8fafcff' },
    { token: 'boolean.yaml', foreground: '18fafcff' }
  ],
  colors: {
    'editor.background': '#29252400',
    'editor.selectionBackground': '#334155ff',
    'editor.inactiveSelectionBackground': '#33415599',
    'editorLineNumber.foreground': '#475569ff',
    'editor.lineHighlightBorder': '#33415500',
    'editorBracketMatch.background': '#00000000',
    'editorBracketMatch.border': '#64748bff',
    'editorSuggestWidget.background': '#334155ff',
    'editorSuggestWidget.selectedBackground': '#94a3b81f',
    'editorSuggestWidget.foreground': '#cbd5e1ff',
    'editorSuggestWidget.selectedForeground': '#cbd5e1ff',
    'editorSuggestWidget.highlightForeground': '#38bdf8ff',
    'editorSuggestWidget.focusHighlightForeground': '#38bdf8ff',
    'editorHoverWidget.background': '#334155ff',
    'editorError.foreground': '#f87171ff',
    'editorWarning.foreground': '#facc15ff'
  }
};

export const lightTheme: editor.IStandaloneThemeData = cloneDeep(darkTheme);

lightTheme.base = 'vs';
lightTheme.colors = {
  'editor.background': '#ffffff00',
  'editor.selectionBackground': '#d6e4f4',
  'editor.inactiveSelectionBackground': '#e5ebf1',
  'editorLineNumber.foreground': '#c5d5ebff',
  'editor.lineHighlightBorder': '#33415500',
  'editorBracketMatch.background': '#00000000',
  'editorBracketMatch.border': '#64748bff',
  'editorSuggestWidget.background': '#ffffff',
  'editorSuggestWidget.selectedBackground': '#d6e4f4',
  'editorSuggestWidget.foreground': '#64748bff',
  'editorSuggestWidget.selectedForeground': '#64748bff',
  'editorSuggestWidget.highlightForeground': '#38bdf8ff',
  'editorSuggestWidget.focusHighlightForeground': '#38bdf8ff',
  'editorHoverWidget.background': '#ffffff',
  'editorError.foreground': '#f87171ff',
  'editorWarning.foreground': '#facc15ff'
};
lightTheme.rules = [
  ...lightTheme.rules,

  { token: 'attribute.name.css', foreground: '008080' },
  { token: 'attribute.value.unit.css', foreground: '99f6e4ff' },
  { token: 'attribute.value.number.css', foreground: '99f6e4ff' },
  { token: 'attribute.value.css', foreground: '99f6e4ff' },
  { token: 'attribute.value.hex.css', foreground: '99f6e4ff' },
  { token: 'comment', foreground: '94a3b8ff' },
  { token: 'string', foreground: 'cde3fcff' },
  { token: 'number', foreground: 'd38b39ff' },
  { token: 'boolean', foreground: 'd38b39ff' },
  { token: 'keyword', foreground: 'd38b39ff' }
];
